import { NgModule } from '@angular/core';
import { RouterModule, Routes,NoPreloading,PreloadAllModules } from '@angular/router';

import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { NewlayoutContentComponent } from './layouts/newlayout-content/newlayout-content.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { FaqComponent } from './pages/faq/faq.component';
import { AboutComponent } from './pages/about/about.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { AuthGuard } from './core/guards/auth.guard';
import { CustomPreload } from './custom-preload.module';
import { ViewInvoiceReceiptPdfComponent } from './modules/admin/pages/view-invoice-receipt-pdf/view-invoice-receipt-pdf.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    component: NewlayoutContentComponent,
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    component: FullLayoutComponent,
    children: [
     
      {
        path: 'faq',
        component: FaqComponent
      },
      {
        path: 'terms',
        component: TermsComponent
      },
      {
        path: 'privacy',
        component: PrivacyComponent
      },
    ]
  },
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard]
      },
     
      {
        path: 'about',
        component: AboutComponent
      },
      {
        path: 'account',
        loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'brandcard',
        loadChildren: () => import('./modules/brandcard/brandcard.module').then(m => m.BrandcardModule)
      }
    ]
  },
  {
    path: 'printreceipt',
    component: ViewInvoiceReceiptPdfComponent
  },
  {
    path: 'error',
    component: FullLayoutComponent,
    loadChildren: () => import('./modules/error/error.module').then(m => m.ErrorModule)
  },
  {
    path: '**',
    redirectTo: '/error/404',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, enableTracing: true, anchorScrolling: 'enabled', preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: []
})

export class AppRoutingModule { }
